export default __webpack_public_path__ + "static/media/883.c4309871.png";